const determineIpType = networkData => {
  if (networkData && networkData.internalIp) {
    return 'ip';
  } else if (networkData && networkData.internalMdns) {
    return 'mdns';
  }
  return 'unknown';
};

export default determineIpType;
